import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';

export default function () {
  const pageable = usePageable();
  pageable.sortField.value = 'code';

  const filters = ref({
    code: {value: null},
    name: {value: null},
    cluster: {value: null},
    city: {value: null},
    postcode: {value: null},
    enabled: {value: null},
  });

  function getQueryParams() {
    const params = pageable.getQueryParams();

    if (filters.value.code?.value != null) {
      params['code'] = filters.value.code.value;
    }

    if (filters.value.name?.value != null) {
      params['name'] = filters.value.name.value;
    }

    if (filters.value.cluster?.value != null) {
      params['cluster'] = filters.value.cluster.value;
    }

    if (filters.value.city?.value != null) {
      params['city'] = filters.value.city.value;
    }

    if (filters.value.postcode?.value != null) {
      params['postcode'] = filters.value.postcode.value;
    }

    if (filters.value.enabled?.value != null) {
      params['enabled'] = filters.value.enabled.value;
    }

    return params;
  }

  return {
    pageable,
    filters,
    getQueryParams,
  }
}


